function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useRef } from "react";
const ImageRender = ({
  icon,
  ...rest
}) => {
  const ImportedIconRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const importIcon = async () => {
    try {
      const {
        default: namedImport
      } = await import(`../../assets/${icon}.svg`);
      ImportedIconRef.current = namedImport;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };
  importIcon();
  if (!loading && ImportedIconRef.current) {
    const {
      current: ImportedIcon
    } = ImportedIconRef;
    return /*#__PURE__*/React.createElement("img", _extends({
      src: ImportedIcon,
      alt: "Logo"
    }, rest));
  }
  return null;
};
export default ImageRender;